module.exports = __webpack_public_path__ + "media/nuvola_low.a5018247.mp4";